class TabelaCodigoChaveBuscaController extends AbstractCrudController

  configure: (configs) ->
    configs.model = 'tabelaCodigoChaveBusca'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'configuracao/tabelas-sped/chave-busca'
    configs.itemName = (item) -> "a Chave de busca por tabela SPED Nº <strong>#{item.id}</strong>"

    @setModal('modalImportar', 'importar', 'tabelaCodigoChaveBuscaImportarController')
    @setModal('modalTabelaCodigoChaveBusca', 'modal', 'tabelaCodigoChaveBuscaModalController')

  initialize: ->
    @inject('tabelaService')

    @listOfTabela = []
    @tabelaService.getList (response) =>
      @listOfTabela = response.data.items

  importar: ->
    @modalImportar(@modalResolve())

  modalResolve: (tabelaCodigoChaveBusca) ->
    {
      tabelaCodigoChaveBusca: => angular.copy(tabelaCodigoChaveBusca)
      listOfTabela: => @listOfTabela
    }

angular.module('eficienciaFiscalModule').controller('tabelaCodigoChaveBuscaController', TabelaCodigoChaveBuscaController)

class TabelaCodigoChaveBuscaModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'tabelaCodigoChaveBuscaService', 'tabelaCodigoChaveBusca', 'listOfTabela' ]

  constructor: ($injector, @modalInstance, @tabelaCodigoChaveBuscaService, @tabelaCodigoChaveBusca, @listOfTabela) ->
    super($injector)

    @submitTracker = @promiseTracker()

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @tabelaCodigoChaveBuscaService.save(@tabelaCodigoChaveBusca, (data) =>
        Alert.success("Chave de busca por tabela SPED Nº <strong>#{data.id}</strong> #{if @tabelaCodigoChaveBusca.id then 'atualizado' else 'criado'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('tabelaCodigoChaveBuscaModalController', TabelaCodigoChaveBuscaModalController)

class TabelaCodigoChaveBuscaImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader' ]

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/tabela-codigo-chave-busca"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
    )

    @uploader.onBeforeUploadItem = (item) =>
      return item

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @Alert.success("A planilha de chaves de busca foi importada com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

angular.module('eficienciaFiscalModule').controller('tabelaCodigoChaveBuscaImportarController', TabelaCodigoChaveBuscaImportarController)